import MultiProgressBar from './MultiProgressBar'

export default MultiProgressBar
